import Page from "@jumbo/shared/Page";
import ListTicket from "app/pages/Tickets/ListTickets";
import AuthenticateAndRolesMiddleware from "../Middleware";

const routesName = "/dashboards/tickets";

export const ticketRoute = [
  {
    middleware: [
      {
        element: AuthenticateAndRolesMiddleware,
        fallbackPath: "/login",
      },
    ],
    routes: [
      {
        path: `${routesName}`,
        element: <Page component={ListTicket} />,
      },
    ],
  },
];
